module.exports = __webpack_public_path__ + "img/voice-icon8.b039831.png";